module.exports = __webpack_public_path__ + "img/07d15a7.png";